/* ================================================================
   VEIL SIGIL TREASURE HUNT
   7 hidden Threefold Sigil triangles scattered across the site.
   Find all 7 to unlock a 10% off code: KRYPTOIDVEIL
   Progress is stored client-side (sessionStorage) — session only,
   cleared when the tab/browser session ends. All 7 must be found
   in the same sitting; nothing carries over day to day.
   ================================================================ */
(function () {
  var TOTAL = 7;
  var STORAGE_KEY = 'pd_veil_sigils';
  var HIDDEN_KEY = 'pd_veil_sigils_hidden';
  var CODE = 'KRYPTOIDVEIL';

  function getFound() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveFound(list) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function isHidden() {
    try { return sessionStorage.getItem(HIDDEN_KEY) === '1'; } catch (e) { return false; }
  }

  function setHidden() {
    try { sessionStorage.setItem(HIDDEN_KEY, '1'); } catch (e) {}
  }

  function applyHiddenState() {
    if (!isHidden()) return;
    document.querySelectorAll('.veil-sigil').forEach(function (el) {
      el.style.display = 'none';
    });
    var badge = document.getElementById('veilSigilBadge');
    if (badge) badge.style.display = 'none';
  }

  function showToast(html, duration) {
    var toast = document.getElementById('veilSigilToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'veilSigilToast';
      toast.className = 'veil-sigil-toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    requestAnimationFrame(function () { toast.classList.add('show'); });
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('show');
    }, duration || 3200);
  }

  function updateBadge() {
    var badge = document.getElementById('veilSigilBadge');
    if (!badge) return;
    var found = getFound();
    var complete = found.length >= TOTAL;
    var logoUrl = window.PD_KRYPTOID_LOGO_URL || 'kryptoid-logo.png';
    badge.innerHTML = '<img src="' + logoUrl + '" alt=""> SIGILS: <span class="veil-badge-count">' + found.length + '/' + TOTAL + '</span>';
    badge.classList.toggle('complete', complete);
    badge.style.pointerEvents = complete ? 'auto' : 'none';
    badge.style.cursor = complete ? 'pointer' : 'default';
    badge.onclick = complete ? showCodeToast : null;
  }

  function showCodeToast() {
    showToast(
      'ALL SEVEN SIGILS DISCOVERED.' +
      '<span class="veil-toast-code">CODE UNLOCKED: ' + CODE + ' &mdash; 10% OFF</span>' +
      '<button type="button" class="veil-toast-hide-btn" onclick="pdSigilHideAll()">HIDE SIGILS</button>',
      9000
    );
  }

  window.pdSigilHideAll = function () {
    setHidden();
    applyHiddenState();
    var toast = document.getElementById('veilSigilToast');
    if (toast) toast.classList.remove('show');
  };

  window.pdSigilFound = function (id) {
    id = String(id);
    var found = getFound();
    var el = document.querySelector('.veil-sigil[data-sigil-id="' + id + '"]');

    if (found.indexOf(id) !== -1) {
      if (el) el.classList.add('found');
      // Once all 7 are found, clicking any sigil again re-shows the code —
      // the unlock toast is transient and disappears on refresh otherwise.
      if (found.length >= TOTAL) {
        showCodeToast();
      } else {
        showToast('ALREADY DISCOVERED &mdash; SIGIL ' + id + ' / ' + TOTAL, 2000);
      }
      return;
    }

    found.push(id);
    saveFound(found);
    if (el) el.classList.add('found');
    updateBadge();

    if (found.length >= TOTAL) {
      showCodeToast();
    } else {
      showToast('SIGIL ' + found.length + ' / ' + TOTAL + ' DISCOVERED', 3000);
    }
  };

  window.pdSigilShowCode = function () {
    var found = getFound();
    if (found.length >= TOTAL) showCodeToast();
  };

  document.addEventListener('DOMContentLoaded', function () {
    var found = getFound();

    document.querySelectorAll('.veil-sigil').forEach(function (el) {
      var id = el.getAttribute('data-sigil-id');
      if (found.indexOf(id) !== -1) el.classList.add('found');
    });

    if (!document.getElementById('veilSigilBadge')) {
      var badge = document.createElement('div');
      badge.id = 'veilSigilBadge';
      badge.className = 'veil-sigil-badge';
      document.body.appendChild(badge);
    }
    updateBadge();
    applyHiddenState();
  });
})();
